<template>
    <v-container class="mt-12 pt-8" style="background:#fafafa;">
      <v-row style="background:#fafafa;">
        <v-col cols="12" class="pa-0">
          <v-row class="py-1 px-5">
            <v-col cols="12">
              <v-card :loading="loading">
                <v-card-text class="py-0 pt-5 pb-5">
                  <!-- Error Alert -->
                  <v-alert
                    v-if="errorAlertVisible"
                    color="red"
                    shaped
                    type="error"
                    dismissible
                    @input="errorAlertVisible = false"
                  >
                    <div v-if="alertMessage !== ''">
                      {{ arabic ? 'حدث خطاء اثناء  ترحيل الطلب الى نينجا ' : 'An error occurred while relaying the request to Ninja' }}
                    </div>
                  </v-alert>
  
                  <!-- Success Alert -->
                  <v-alert
                    v-if="successAlertVisible"
                    color="green"
                    shaped
                    type="success"
                    dismissible
                    @input="successAlertVisible = false"
                  >
                    <div v-if="alertMessage !== ''">
                      {{ arabic ? 'تمت عملية الترحيل الى نينجا  بنجاح' : 'The migration to Ninja was completed successfully.' }}
                    </div>
                  </v-alert>
  
                  <!-- If the subscription is active, show content -->
                  <div>
                    <!-- Filter list and data visualization -->
                    <FilterList :i18n="i18n" @filter-applied="onFilterApplied" />
                    <v-dialog v-model="showDialog" persistent max-width="600px">
                      <template>
                        <v-card>
                          <v-card-title>
                            <v-spacer></v-spacer>
                            <v-btn icon @click="showDialog = false">
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </v-card-title>
                          <v-container>
                            <v-card-text>
                              <v-simple-table class="text-center mb-5">
                                <thead>
                                  <tr>
                                    <th class="text-center">Label</th>
                                    <th class="text-center">Field Value</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="item in submissionDataFields" :key="item.id">
                                    <td class="text-center">{{ item.label }}</td>
                                    <td class="text-center">{{ item.field_value }}</td>
                                  </tr>
                                </tbody>
                              </v-simple-table>

                              <v-simple-table class="text-center table_offer">
                                <thead>
                                  <tr>
                                    <th class="text-center">Offer Label</th>
                                    <th class="text-center">Price (Offer)</th>
                                    <th class="text-center">Item Name</th>
                                    <th class="text-center">Currency</th>
                                    <th class="text-center">Quantity</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <template v-for="submission in submissionData">
                                    <tr v-for="offerProduct in submission.form_offer.form_offer_products" :key="offerProduct.id">
                                      <td class="text-center">{{ submission.form_offer.label }}</td>
                                      <td class="text-center">{{ submission.form_offer.price }}</td>
                                      <td class="text-center">{{ offerProduct.product.item_name }}</td>
                                      <td class="text-center">{{ submission.form_offer.currency }}</td>
                                      <td class="text-center">{{ offerProduct.quantity }}</td>
                                    </tr>
                                  </template>
                                </tbody>
                              </v-simple-table>
                            </v-card-text>
                          </v-container>
                          <v-card-actions></v-card-actions>
                        </v-card>
                      </template>
                    </v-dialog>
  
                    <!-- List of results -->
                    <div class="text-center my-3">
                      <v-btn color="success" :loading="loading" text small @click="reload()">{{i18n['reload']}}</v-btn>
                    </div>
                    <v-pagination v-model="currentPage" :length="totalPages" @input="fetchFormResults"></v-pagination>

                    <v-simple-table>
                      <thead>
                        <tr>
                          <td :class="`${arabic ? 'arFont' : 'enFont'}`">{{ arabic ? 'Ip address' : 'Ip address' }}</td>
                          <td :class="`${arabic ? 'arFont' : 'enFont'}`">{{ arabic ? 'العرض' : 'The Offer' }}</td>
                          <td :class="`${arabic ? 'arFont' : 'enFont'}`">{{ arabic ? 'تاريخ التقديم' : 'Submission Date' }}</td>
                          <td :class="`${arabic ? 'arFont' : 'enFont'}`">{{ arabic ? 'الدولة' : 'Country' }}</td>
                          <td :class="`${arabic ? 'arFont' : 'enFont'}`">{{ arabic ? 'ملاحظة نبنجا' : 'Ninja Note' }}</td>
                          <td :class="`${arabic ? 'arFont' : 'enFont'}`">{{ arabic ? 'Action' : ' Action' }}</td>
                          <td :class="`${arabic ? 'arFont' : 'enFont'}`"><v-btn  @click="ninjaIsSyncAll()" x-small color="success">Ninja Sync all</v-btn></td>

                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="result in formResults" :key="result.id">
                          <td :class="`${arabic ? 'arFont' : 'enFont'}`">{{ result.ip_address }}</td>
                          <td :class="`${arabic ? 'arFont' : 'enFont'}`">{{ result.form_offer.label }}</td>
                          <td :class="`${arabic ? 'arFont' : 'enFont'}`">{{ formatDate(result.created_at) }}</td>
                          <td :class="`${arabic ? 'arFont' : 'enFont'}`">{{ result.form.country.name }}</td>
                          <td :class="`${arabic ? 'arFont' : 'enFont'}`">{{ result.ninja_sync_note }}
                       <div v-if="result.uuid !='' || result.uuid !=null "> {{ result.uuid }} </div>
                        </td>
                          <td>
                            <v-btn color="primary" x-small icon @click="showForm(result.id)" style="margin-right:20px;margin-left:20px">
                              <v-icon size="20">visibility</v-icon>
                            </v-btn>
                            <v-btn :disabled="!is_subscription || !!result.ninja_is_sync" x-small color="success" @click="ninjaIsSync(result.id)">Ninja Sync</v-btn>
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                    <!-- Pagination Component -->
                    <v-pagination v-model="currentPage" :length="totalPages" @input="fetchFormResults"></v-pagination>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  import FilterList from '@/components/FormBuilder/ListFilterSubmission.vue';
  
  export default {
    components: {
      FilterList,
    },
    data() {
      return {
        submissionDataFields: [],
        submissionData: [],
        filterCriteria: {
          inputSearch: '',
          fromDate: '',
          toDate: '',
          is_sync:null,
        },
        currentPage: 1,
        limit: 10,
        totalPages: 0,
        loading: false,
        showDialog: false,
        formResults: [],
        is_subscription: false,
        alertVisible: false,
        alertMessage: '',
        errorAlertVisible: false,
        successAlertVisible: false,
      };
    },
    methods: {
      async fetchSubmissionData(formSubmissionId) {
        try {
          const response = await this.$store.dispatch('getResource', {
            resource: `/getSubmissionDataForm/${formSubmissionId}`,
          });
          this.submissionDataFields = response.data;
  
          const unique = new Map();
          response.data.forEach((item) => {
            const uniqueKey = `${item.form_submission.productName}-${item.form_submission.price}-${item.form_submission.description}-${item.form_submission.currency}`;
            if (!unique.has(uniqueKey)) {
              unique.set(uniqueKey, item.form_submission);
            }
          });
  
          this.submissionData = Array.from(unique.values());
          this.showDialog = true;
        } catch (error) {
          console.error('Error fetching submission data:', error);
        }
      },
      async ninjaIsSync(formSubmissionId) {
        try {
            this.loading = true;
        this.fetchFormResults();

          const response = await this.$store.dispatch('postResource', {
            resource: `/ninja-sync/${formSubmissionId}`,
            
          });
          this.loading = false;

          const data = response;
  
          if (data.status === 'success') {
            this.loading = false;

            this.fetchFormResults();
            this.successAlertVisible = true;
            this.errorAlertVisible = false;
            this.alertMessage = data.message;
            console.log('Response data:', this.alertMessage);
            this.loading = false;

          } else if (data.status === 'error') {
            this.loading = false;

            this.fetchFormResults();
            this.alertMessage = data.message;
            this.errorAlertVisible = true;
            this.successAlertVisible = false;
            console.log('Response data:', this.alertMessage);

          }
        } catch (error) {
            this.loading = false;

          console.error(error);
          this.fetchFormResults();
          this.errorAlertVisible = true;
          this.successAlertVisible = false;
          console.log('Error:', error.message);
        }
      },
      async checkSubscription() {
        try {
          const response = await this.$store.dispatch('getResource', {
            resource: '/checkSubscription',
          });
          if (response && response.status) {
            this.is_subscription = response.status === 'is_active';
            console.log('Subscription status:', this.is_subscription ? 'Active' : 'Inactive');
          } else {
            console.log('No subscription status found in the response.');
            this.is_subscription = false;
          }
        } catch (error) {
          console.error('Error fetching data:', error);
          this.is_subscription = false;
        }
      },
      showForm(id) {
        this.fetchSubmissionData(id);
      },
      onFilterApplied(filterCriteria) {
        this.filterCriteria = filterCriteria;
        this.fetchFormResults();
      },
      async fetchFormResults() {
        const params = {
          page: this.currentPage,
          fromDate: this.filterCriteria.fromDate,
          toDate: this.filterCriteria.toDate,
          inputSearch: this.filterCriteria.inputSearch,
          is_sync: this.filterCriteria.is_sync,

          limit: this.limit,
        };
        this.loading = true;
        try {
          const response = await this.$store.dispatch('getResource', {
            resource: `/formSubmissionData/${this.$route.params.id}`,
            filters: params,
          });
          this.formResults = response.data.data;
          this.totalPages = response.data.last_page; // Make sure to access the correct field from response
          console.log(this.formResults);
        } catch (error) {
          console.error('Error fetching form results:', error);
        } finally {
          this.loading = false;
        }
      },
      //sync all-ninja
      async ninjaIsSyncAll() {
          let form_id = this.$route.params.id;
          this.loading = true;
            try 
            {
                const response = await this.$store.dispatch('postResource', {
                    resource: `/ninja-sync-all/${form_id}`
                });
                this.loading = false;
                if (response.status === 'success') {
                    this.successAlertVisible = true;
                    this.errorAlertVisible = false;
                    this.alertMessage = response.message;
                } else if (response.status === 'error') {
                    this.errorAlertVisible = true;
                    this.successAlertVisible = false;
                    this.alertMessage = response.message;
                }
                console.log('Response data:', this.alertMessage);
                this.fetchFormResults();
            } catch (error) {
                this.loading = false;
                this.errorAlertVisible = true;
                this.successAlertVisible = false;
                this.alertMessage = error.message;
                console.error('Error:', error.message);
                this.fetchFormResults();
            }
       },


      async reload() {
        this.fetchFormResults();
      },
      formatDate(dateString) {
        const options = {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        };
        return new Date(dateString).toLocaleDateString(undefined, options);
      },
      navigateToPlanPrice() {
        this.$router.push({ name: 'plan_price' });
      },
    },
    mounted() {
      this.fetchFormResults();
      this.checkSubscription();
    },
    computed: {
      language() {
        return this.$store.state.language;
      },
      i18n() {
        return this.$store.state.i18n[this.$store.state.language];
      },
      arabic() {
        return this.$store.state.language === 'ar';
      },
    },
  };
  </script>
  
  <style scoped>
  /* Add your styles here */
  </style>
  